<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Nr4P1s/tc-custom/9780300138870.jpg?1704916909406" alt="This image is the cover for the book FBI"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">FBI
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This “penetrating and remarkable history of the FBI” examines its operations and development from the Reconstruction era to the 9/11 attacks (M. J. Heale, author of <i>McCarthy's Americans</i>).</b><br/><br/> In <i>The FBI</i>, U.S. intelligence expert Rhodri Jeffreys-Jones presents the first comprehensive portrait of the vast, powerful, and sometimes bitterly criticized American institution. Setting the bureau’s story in the context of American history, he challenges conventional narratives—including the common misconception that traces the origin of the bureau to 1908. Instead, Jeffreys-Jones locates the FBI’s true beginnings in the 1870s, when Congress acted in response to the Ku Klux Klan campaign of terror against black American voters.<br/>  <br/> The FBI derives its character and significance from its original mission of combating domestic terrorism. The author traces the evolution of that mission into the twenty-first century, making a number of surprising observations along the way: that the role of J. Edgar Hoover has been exaggerated and the importance of attorneys general underestimated; that splitting counterintelligence between the FBI and the CIA in 1947 was a mistake; and that xenophobia impaired the bureau’s preemptive anti-terrorist powers before and after 9/11.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rhodri Jeffreys-Jones
      </h2>
      
      <p class="authorDescription body article">Rhodri Jeffreys-Jones is professor emeritus of American history, Edinburgh University. His previous books include The CIA and American Democracy, Peace Now! American Society and the Ending of the Vietnam War, and Cloak and Dollar: A History of American Secret Intelligence, all published by Yale University Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c7949fa